/*
 *
 * File JS per la Logo PAGE
 *
 */


import Swiper, { EffectCoverflow, A11y, Navigation, Pagination } from "swiper";


// IMPORT COMPONENTI
//--------------------------------------------------------------------//

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import "./logo.scss";

//--------------------------------------------------------------------//

// INIT COMPONENTI
//--------------------------------------------------------------------//

//--------------------------------------------------------------------//


const logo = () => {

  const pagelogo = document.querySelector('.pg-logo');
  if(!pagelogo) return;

  new Swiper('.pg-logo .swiper-container', {
    modules: [EffectCoverflow, A11y, Navigation, Pagination ],
    effect: 'coverflow',
    loop: true,
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    spaceBetween: -180,
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar',
    },
    navigation: {
      nextEl: ".swiper-button-next-logo",
      prevEl: ".swiper-button-prev-logo",
    },
    A11y: {
      enabled: true,
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      notificationClass: "swiper-notification",
    },
  });

}

logo();

